/**
 * created on: 2019.04.08
 * 串联单详情页路由
 */
'use strict';
angular.module('televisionPreviewRouterModule', [
		'seriesSheetPreviewModule',
        'manuscriptPreviewModule'
	])
    .config(['$stateProvider', function($stateProvider) {
    	$stateProvider.state('seriesSheetPreview', {
    		url: '/seriessheetpreview?tvchannelid&tvchnldocid&tvsiteid&tvmetadataid&tvplatform&isfromplannedorder&fromsearch',
    		views: {
    			'': {
    				templateUrl: "./editingCenter/television/preview/seriesSheetPreview/seriesSheetPreview_tpl.html",
                    controller: "seriesSheetPreviewCtrl"
    			}
    		}
    	}).state('manuscriptPreview', {
            url: '/manuscriptPreview?tvchannelid&tvchnldocid&tvsiteid&tvmetadataid&tvplatform&tvtypeid&isfromplannedorder&fromsearch',
            views: {
                '': {
                    templateUrl: "./editingCenter/television/preview/manuscriptPreview/manuscriptPreview_tpl.html",
                    controller: "manuscriptPreviewCtrl"
                }
            }
        })
    }]);